/**
 * Created by shenchangmin on 2017/2/10.
 */
import Vue from 'vue'

const mutations = {
  SAVE_USER_INFO: (state, {name, logoPic, isOperator, isDubAnchor}) => {
    Vue.set(state.user, 'name', name)
    Vue.set(state.user, 'login', true)
    Vue.set(state.user, 'logoPic', logoPic)
    Vue.set(state.user, 'isOperator', isOperator)
    Vue.set(state.user, 'isDubAnchor', isDubAnchor)
  },
  SET_USER_STATUS: (state, {authorProgressStatus, authorProgressLabel, type, typeLabel, rejectionReason}) => {
    Vue.set(state.user.author, 'authorProgressStatus', authorProgressStatus)
    Vue.set(state.user.author, 'authorProgressLabel', authorProgressLabel)
    Vue.set(state.user.author, 'type', type)
    Vue.set(state.user.author, 'typeLabel', typeLabel)
    Vue.set(state.user.author, 'rejectionReason', rejectionReason)
  },
  SET_ANCHOR_STATUS: (state, {level, type}) => {
    Vue.set(state.user.anchor, 'level', level)
    Vue.set(state.user.anchor, 'type', type)
  },
  UPDATE_UNHANDLE_EVENT: (state, value) => {
    state.UNHANDLE_EVENT = value
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js